import { create } from "zustand";

/**
 * Tiny cross-subtree signal: the "Podgląd ekranu" button lives in the TopBar
 * while the picker is rendered by the globally-mounted ScreenShareHost. The
 * actual session state machine + WebRTC objects live in useScreenShare (refs in
 * the Host), never here — this store only toggles the picker open/closed.
 */
interface ScreenShareUiState {
  pickerOpen: boolean;
  setPickerOpen: (open: boolean) => void;
  /**
   * Ends the live session, if any — registered by the Host hook. Lets code
   * outside the Host subtree (e.g. TopBar logout) tear the stream down while the
   * user is still authenticated, so the peer gets a clean `end`.
   */
  endActive: (() => void) | null;
  setEndActive: (fn: (() => void) | null) => void;
}

export const useScreenShareUiStore = create<ScreenShareUiState>((set) => ({
  pickerOpen: false,
  setPickerOpen: (pickerOpen) => set({ pickerOpen }),
  endActive: null,
  setEndActive: (endActive) => set({ endActive }),
}));
